export enum EPasswordCriteriaType {
  LIRUNEX_CRM = 'LIRUNEX_CRM',
  METATRADER_PLATFORM = 'METATRADER_PLATFORM',
  MITRADER_CRM = 'MITRADER_CRM'
}

export const PASSWORD_LENGTH = {
  [EPasswordCriteriaType.LIRUNEX_CRM]: { min: 8, max: 12 },
  [EPasswordCriteriaType.METATRADER_PLATFORM]: { min: 12, max: 20 },
  [EPasswordCriteriaType.MITRADER_CRM]: { min: 6, max: 18 }
};
